import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const productCategories = [
  {
    id: 'construction-lumber',
    label: 'Construction Lumber',
    products: ['Dimensional Lumber', 'Framing Lumber', 'Structural Beams'],
    description: 'High-quality construction lumber for residential and commercial framing, structural applications, and general building use. Sourced from certified South American forests.',
    image: 'https://storage.readdy-site.link/project_files/dd5028de-19b2-46ba-b682-1ec36c54fca8/7543504e-4630-45e9-aa52-21459b1e6ded_construction_lumber.jpg?v=05726f66214f7a8aba9c66fc1ac878c0',
    tag: 'Lumber',
  },
  {
    id: 'fencing',
    label: 'Fencing',
    products: ['Fencing Boards', 'Fencing Posts', 'Pickets'],
    description: 'Premium kiln-dried cedar and pine fencing boards and posts — durable, dimensionally stable, and ready for installation in residential and commercial projects.',
    image: 'https://storage.readdy-site.link/project_files/dd5028de-19b2-46ba-b682-1ec36c54fca8/d10901a6-66a0-4bc8-8e94-1b7132168745_fencing.jpg?v=1135ec7dd3aee6313fcf74e7ebd2792b',
    tag: 'Outdoor',
  },
  {
    id: 'furniture-lumber',
    label: 'Furniture Lumber',
    products: ['Hardwood Boards', 'Furniture Grade Lumber', 'Appearance Boards'],
    description: 'Select-grade lumber ideal for furniture manufacturing, cabinetry, and fine woodworking. Smooth surfaces, tight grain, and consistent quality throughout.',
    image: 'https://storage.readdy-site.link/project_files/dd5028de-19b2-46ba-b682-1ec36c54fca8/10e9c37a-64b2-4a48-b2f1-6b41e90a0060_furniture_lumber.jpg?v=5cbf5f544d7bf3e10d8d9830bca91b9c',
    tag: 'Lumber',
  },
  {
    id: 'treated-lumber',
    label: 'Treated Lumber',
    products: ['Pressure-Treated Lumber', 'Ground Contact Lumber', 'Above Ground Lumber'],
    description: 'Pressure-treated lumber for outdoor, ground-contact, and marine applications — engineered for longevity, rot resistance, and structural durability in harsh environments.',
    image: 'https://storage.readdy-site.link/project_files/dd5028de-19b2-46ba-b682-1ec36c54fca8/85cff451-afeb-48bf-b871-5c5772847134_treated_lumber.jpg?v=3238067a6b483f31b686fb41bfe4744a',
    tag: 'Treated',
  },
  {
    id: 'pallet-lumber',
    label: 'Pallet Lumber',
    products: ['Pallet KD Lumber', 'Pallet Boards', 'Pallet Stringers'],
    description: 'Kiln-dried lumber specifically designed for pallet manufacturing — precise dimensions, low moisture content, and superior strength for reliable load-bearing performance.',
    image: 'https://storage.readdy-site.link/project_files/dd5028de-19b2-46ba-b682-1ec36c54fca8/cbecefe3-7f2a-4aec-af83-01dface9dc43_pallet_lumber.jpg?v=1c767fb23eca0f6dc12a1bc3f1ec1fc1',
    tag: 'Lumber',
  },
  {
    id: 'hdf',
    label: 'HDF',
    products: ['High Density Fiberboard', 'HDF Panels', 'HDF Flooring Substrate'],
    description: 'High Density Fiberboard panels offering superior hardness and smooth surface finish — ideal for flooring substrates, door skins, and high-wear surface applications.',
    image: 'https://storage.readdy-site.link/project_files/dd5028de-19b2-46ba-b682-1ec36c54fca8/fa736c06-c123-47a7-8cdf-c62e6f3d27a0_HDF.jpg?v=ad455476e0c5b110d47de1e9c3320fc7',
    tag: 'Panels',
  },
  {
    id: 'mdf',
    label: 'MDF',
    products: ['Standard MDF', 'Moisture Resistant MDF', 'Fire Retardant MDF'],
    description: 'Medium Density Fiberboard with consistent density and ultra-smooth surface — the go-to engineered panel for furniture, cabinetry, millwork, and interior applications.',
    image: 'https://storage.readdy-site.link/project_files/dd5028de-19b2-46ba-b682-1ec36c54fca8/54672151-e115-4d11-accd-8a9988beb01d_MDF.jpg?v=89f4f73381fc02bfcac661fa1f9f5e0f',
    tag: 'Panels',
  },
  {
    id: 'mdp',
    label: 'MDP',
    products: ['Medium Density Particleboard', 'Raw MDP', 'Melamine MDP'],
    description: 'Medium Density Particleboard engineered for furniture manufacturing, shelving, and interior construction. Available raw or with melamine overlay for finished surfaces.',
    image: 'https://storage.readdy-site.link/project_files/dd5028de-19b2-46ba-b682-1ec36c54fca8/2bac0960-29fb-43b7-8ffc-0b300c1ba120_mdp.jpg?v=d33c07e67ea97199f9538f6b75be7183',
    tag: 'Panels',
  },
  {
    id: 'plywood',
    label: 'Plywood',
    products: ['ACx', 'BCx', 'CDx', 'HDO', 'MDO', 'PSF'],
    description: 'Structural and decorative plywood in multiple grades — ACx, BCx, CDx, HDO, MDO, and PSF — for construction, forming, and finishing applications.',
    image: 'https://storage.readdy-site.link/project_files/dd5028de-19b2-46ba-b682-1ec36c54fca8/54bd2e69-0f1d-477d-855b-a7ee87a25348_plywood.jpg?v=b08aca2411703e5a097258cdb1b8972d',
    tag: 'Structural',
  },
  {
    id: 'veneers',
    label: 'Veneers',
    products: ['Face Veneers', 'Decorative Veneers', 'Rotary Cut Veneers', 'Sliced Veneers'],
    description: 'Premium wood veneers for decorative surfacing, furniture facing, and architectural millwork. Available in a wide range of species, cuts, and thicknesses.',
    image: 'https://storage.readdy-site.link/project_files/dd5028de-19b2-46ba-b682-1ec36c54fca8/74fd9c97-7581-401e-954a-76a79c147df5_veneers.jpg?v=4f15c46dba32b3a4cb43eed9550ccd79',
    tag: 'Specialty',
  },
  {
    id: 'molding',
    label: 'Molding',
    products: ['Base Molding', 'Crown Molding', 'Casing', 'Door Stop', 'Chair Rail'],
    description: 'Precision-milled wood moldings for interior trim, architectural detailing, and finish carpentry. Consistent profiles, smooth surfaces, and paint-ready quality.',
    image: 'https://storage.readdy-site.link/project_files/dd5028de-19b2-46ba-b682-1ec36c54fca8/8de3cf86-8855-477f-8ae7-aa720bac7e2e_molding.jpg?v=38d8d66cfa1fa92412ef664027436763',
    tag: 'Millwork',
  },
  {
    id: 'osb',
    label: 'OSB',
    products: ['OSB/2', 'OSB/3', 'OSB/4'],
    description: 'Oriented Strand Board for wall sheathing, roof decking, and subfloor applications. Consistent quality and structural performance across all exposure categories.',
    image: 'https://storage.readdy-site.link/project_files/dd5028de-19b2-46ba-b682-1ec36c54fca8/ee73ca0c-e669-4938-b064-235af5a631fd_osb.jpg?v=1559f7967d7a51fae85020ac018b478c',
    tag: 'Structural',
  },
];

export default function ProductsSection() {
  const { ref, isVisible } = useScrollAnimation();
  const [activeProduct, setActiveProduct] = useState(productCategories[0]);

  return (
    <section id="products" className="py-24 lg:py-32 bg-[#1C3A2C] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div
          ref={ref}
          className={`flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 border border-white/20 rounded-full mb-6">
              <span className="w-2 h-2 rounded-full bg-[#C68B3C] inline-block"></span>
              <span className="text-white/70 text-xs font-semibold tracking-widest uppercase">Our Products</span>
            </div>
            <h2 className="font-playfair text-3xl md:text-5xl text-white font-semibold leading-tight">
              Premium Forest Products<br />
              <em className="italic font-normal text-[#7AA882]">For Every Application</em>
            </h2>
          </div>
          <p className="text-white/60 text-sm leading-relaxed max-w-xs">
            Sourced from certified suppliers from across the world — delivered to the U.S. market.
          </p>
        </div>

        {/* Product selector tabs */}
        <div className="flex flex-wrap gap-3 mb-10">
          {productCategories.map((cat) => (
            <button
              key={cat.id}
              data-product-id={cat.id}
              onClick={() => setActiveProduct(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                activeProduct.id === cat.id
                  ? 'bg-[#C68B3C] text-white'
                  : 'bg-white/10 text-white/70 hover:bg-white/20 hover:text-white'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* Active product display */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="rounded-2xl overflow-hidden w-full h-64 md:h-80 lg:h-96">
            <img
              key={activeProduct.id}
              src={activeProduct.image}
              alt={activeProduct.label}
              className="w-full h-full object-cover object-top transition-opacity duration-300"
            />
          </div>
          <div>
            <span className="inline-block px-3 py-1 bg-[#C68B3C]/20 text-[#C68B3C] text-xs font-semibold rounded-full tracking-wider uppercase mb-4">
              {activeProduct.tag}
            </span>
            <h3 className="font-playfair text-2xl md:text-3xl text-white font-semibold mb-4">
              {activeProduct.label}
            </h3>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              {activeProduct.description}
            </p>
            <div className="flex flex-wrap gap-2 mb-8">
              {activeProduct.products.map((p) => (
                <span
                  key={p}
                  className="px-3 py-1.5 bg-white/10 text-white/80 text-xs font-medium rounded-lg"
                >
                  {p}
                </span>
              ))}
            </div>
            <button
              onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#2D5E3F] text-white text-sm font-medium rounded-full hover:bg-[#4A8563] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Request This Product
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
